export const ty = 2024

